import React from 'react';

// Components
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import WpButton from 'Wpds/components/button/WpButton';

// Styles
import './ItemDoesntExistError.scss';

type Props = {
  title?: string;
  description?: string;
  image?: Illustrations;
  buttonLabel?: string;
  buttonCallback?: () => void;
};

const ItemDoesntExistError = ({ title, description, image, buttonLabel = 'Take me back', buttonCallback }: Props) => {
  const showTitle = !!title;
  const showDescription = !!description;
  const showButton = buttonLabel && buttonCallback;
  const imgSrc = image || Illustrations.person_working_from_bench_white_bg;

  const baseClassName = 'ItemDoesntExistError';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__error`}>
        <div className={`${baseClassName}__error__content`}>
          <WpIllustration className={`${baseClassName}__error__content__image`} src={imgSrc} alt={imgSrc} />
          {showTitle && <h5>{title}</h5>}
          {showDescription && <p className={`${baseClassName}__error__content__description`}>{description}</p>}
          {showButton && <WpButton onClick={buttonCallback}>{buttonLabel}</WpButton>}
        </div>
      </div>
    </div>
  );
};

export default ItemDoesntExistError;
